import { type } from 'os';
import { useEffect } from 'react';

export enum KeyEnum {
  ESCAPE = 'Escape',
  CTRL = 'Control',
  ALT = 'Alt',
  ENTER = 'Enter',
  SHIFT = 'Shift',
  META = 'Meta',
  BACKSPACE = 'Backspace',
  ARROW_DOWN = 'ArrowDown',
  ARROW_UP = 'ArrowUp',
}

export function useCloseKeyBinder(action: () => void) {
  useKeyBinder(action, KeyEnum.ESCAPE);
}

export default function useKeyBinder(
  action: (e: KeyboardEvent) => void,
  binders: KeyEnum[] | KeyEnum,
) {
  const keypress = (e: KeyboardEvent) => {
    if (typeof binders === 'string') {
      if (binders === e.key) {
        action(e);
      }
    }

    if (Array.isArray(binders)) {
      const match = binders.reduce(
        (acc, binding) => (acc = acc && binding == e.key),
        true,
      );

      if (match) {
        action(e);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', keypress, false);

    return () => window.removeEventListener('keydown', keypress, false);
  });
}
